import { apiActions } from '../../../_core/api';
import { Middleware } from 'redux';
import { IStore } from '../../../store';
import bfl2Actions, {
	EBFL2Actions,
	EBFL2Constants,
	TBFL2Actions,
} from '../actions';
import { jobActions } from '../../../_core/job';
import { IAuthActions } from '../../auth/actions';
import { commonUtils } from '../../../_common';
import { TBFL2BackendRecord } from '../@types';
import { EMARPOLDocuments, EMARPOLModelName } from 'redux/app/marpol/@types';

const bfl2HistoryMiddleware: Middleware<{}, IStore> =
	({ dispatch, getState }) =>
		(next) =>
			(action: TBFL2Actions | IAuthActions) => {
				switch (action.type) {
					case EBFL2Actions.HISTORY_LOAD: {
						next(action);
						const job = jobActions(EBFL2Constants.FEATURE, action.type);
						const { providedFilters: filters } = action.payload;
						dispatch(bfl2Actions.document.setFilter(filters));

						dispatch(
							apiActions.apiRequest<{ logs: { docs: TBFL2BackendRecord[] } }>({
								feature: action.type,
								method: 'GET',
								url: EBFL2Constants.API,
								queryParams: {
									vesselId: filters.vesselId,
									marpolType: EMARPOLDocuments.BFL2,
									modelName: EMARPOLModelName.MARPOL,
									weekStart: filters.startDate,
									weekEnd: filters.endDate,
									state: {
										$eq: filters?.state ?? undefined
									},
									sortOrder: filters?.sortOrder ?? undefined,
								},
								preExecute() {
									dispatch(job.active({}));
								},
								postExecute: {
									onSuccess({ data }) {
										const bfl1Records = data.logs.docs.filter(
											(doc) => doc.marpolType === EMARPOLDocuments.BFL2
										);
										dispatch(
											bfl2Actions.document.historySet(
												commonUtils.arrayToObject(bfl1Records)
											)
										);
										dispatch(job.success({}));
									},
									onError() {
										dispatch(job.error({}));
									},
									finally() {
										dispatch(job.idle({}));
									},
								},
							})
						);
						break;
					}
					default: {
						next(action);
						break;
					}
				}
			};
export default bfl2HistoryMiddleware;
